<template>

    <v-container>
        <v-layout row wrap>
            <!-- <v-flex xs12 sm8 md12>
                <section-header v-text="page.title"></section-header>
                <div class="subheading justify" v-html="page.description"></div>
                <div class="my-5"></div>
            </v-flex> -->
            <v-toolbar color="orange" dense tabs>
                <v-tabs v-model="currentItem" color="transparent" fixed-tabs slider-color="accent">
                    <v-tab v-for="item in items" :href="'#tab-' + item" :key="item">{{ item }}</v-tab>
                </v-tabs>
            </v-toolbar>
            <v-tabs-items v-model="currentItem">
                <v-tab-item value="tab-Signature">
                     <v-flex lg12 md12 sm12 xs12 align-center>
                        <v-card>
                            <v-card-text>
                                <signature></signature>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-tab-item>
                <v-tab-item value="tab-Certification">
                    <v-flex lg12 md12 sm12 xs12 align-center>
                        <v-card>
                            <v-card-text>
                                <certified-notification></certified-notification>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-tab-item>
                <v-tab-item value="tab-Identification">
                    <v-flex lg12 md12 sm12 xs12 align-center>
                        <v-card>
                            <v-card-text>
                                <identification></identification>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-tab-item>
            </v-tabs-items>
        </v-layout>
    </v-container>
</template>

<script>
import Signature from "./SignaturePage";
import CertifiedNotification from "./CertifiedNotificationPage";
import Identification from "./IdentificationPage";
export default {
  name: "ProductsPage",
  components: {
    Signature,
    CertifiedNotification,
    Identification
  },
//   mounted() {
//     // Google Analytics
//     this.$ga.page(this.$router);
//   },
  data() {
    return {
      currentItem: "tab-Signature",
      items: ["Signature", "Certification", "Identification"]
    };
  }
};
</script>

<style scoped>
</style>
